var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-shipment-option"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-prepend col-md-8 custom-radio"
  }, [_c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "id": "single",
      "value": "single"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "single")
    },
    on: {
      "change": function($event) {
        _vm.picked = "single"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v(" Update Address using Parent MPS ")])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-text btn btn-sm btn-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "id": "bulk",
      "value": "bulk"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "bulk")
    },
    on: {
      "change": function($event) {
        _vm.picked = "bulk"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v(" Update Final Destination ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.picked == 'single') ? _c('div', {
    staticClass: "card"
  }, [_c('legend', [_vm._v("Update Address using Parent MPS")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Parentmps),
      expression: "Parentmps"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Parentmps')
    },
    attrs: {
      "id": "Parentmps",
      "type": "text",
      "name": "Parentmps",
      "placeholder": "Please Enter Parent MPS",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57"
    },
    domProps: {
      "value": (_vm.Parentmps)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Parentmps = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Parentmps')),
      expression: "errors.has('form-1.Parentmps')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Valid Parent MPS")]), _vm._v(" "), _c('span', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    on: {
      "click": _vm.clear
    }
  }), _vm._v("Reset")])])], 1)])]), _vm._v(" "), (_vm.shipdetailsFlag == true) ? _c('div', {
    staticClass: "shipments-details-shows"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-3"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm3('form-3')
      }
    }
  }, [_c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.shippingAddress),
      expression: "shipDetails.shippingAddress"
    }],
    ref: "textarea",
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "name": "shippingAddress",
      "id": "shippingAddress"
    },
    domProps: {
      "value": (_vm.shipDetails.shippingAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipDetails, "shippingAddress", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingState),
      expression: "shipDetails.ShippingState"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingState')
    },
    attrs: {
      "id": "ShippingState",
      "name": "ShippingState"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shipDetails, "ShippingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getCity]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select State--")]), _vm._v(" "), _vm._l((_vm.newRTOStateObj), function(state_obj) {
    return _c('option', {
      domProps: {
        "value": state_obj.stateid
      }
    }, [_vm._v(_vm._s(state_obj.statename))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingCity),
      expression: "shipDetails.ShippingCity"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingCity')
    },
    attrs: {
      "id": "ShippingCity",
      "name": "ShippingCity"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shipDetails, "ShippingCity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select city--")]), _vm._v(" "), _vm._l((_vm.newRTOCityObj), function(city_obj) {
    return _c('option', {
      domProps: {
        "value": city_obj.cityid
      }
    }, [_vm._v(_vm._s(city_obj.cityname))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.mobileno),
      expression: "shipDetails.mobileno"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('mobileno')
    },
    attrs: {
      "id": "mobileno",
      "type": "text",
      "name": "mobileno",
      "placeholder": "Please Enter mobile no",
      "minlength": "10",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.shipDetails.mobileno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipDetails, "mobileno", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.mobileno')),
      expression: "errors.has('form-3.mobileno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter mobile no")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingPincode),
      expression: "shipDetails.ShippingPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShippingPincode')
    },
    attrs: {
      "id": "ShippingPincode",
      "type": "text",
      "name": "ShippingPincode",
      "placeholder": "Please Enter Pincode",
      "minlength": "6",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.shipDetails.ShippingPincode)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.shipDetails, "ShippingPincode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.ShippingPincode')),
      expression: "errors.has('form-3.ShippingPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Pincode")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shipDetails.ShippingComments),
      expression: "shipDetails.ShippingComments"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('RTOReason')
    },
    attrs: {
      "id": "ShippingComments",
      "name": "ShippingComments"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.shipDetails, "ShippingComments", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select reason--")]), _vm._v(" "), _vm._l((_vm.reasonObj), function(Reason_obj) {
    return _c('option', {
      domProps: {
        "value": Reason_obj.ReasonsID
      }
    }, [_vm._v(_vm._s(Reason_obj.Reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-3.ShippingComments')),
      expression: "errors.has('form-3.ShippingComments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Reason.")])], 1)]), _vm._v(" "), _vm._m(8)])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.picked == 'bulk') ? _c('div', {
    staticClass: "card"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm1('form-2')
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(10), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBType),
      expression: "AWBType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|'),
      expression: "'required|'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('form-1.AWBType')
    },
    attrs: {
      "id": "AWBType",
      "name": "AWBType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.AWBType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.AwbType]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select AWB Type --")]), _vm._v(" "), _vm._l((_vm.AWBTypeObj), function(AWBType_obj) {
    return _c('option', {
      domProps: {
        "value": AWBType_obj.id
      }
    }, [_vm._v(_vm._s(AWBType_obj.type))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.AWBType')),
      expression: "errors.has('form-2.AWBType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select AWB Type. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(11), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShipment),
      expression: "txtShipment"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtShipment')
    },
    attrs: {
      "id": "txtShipment",
      "type": "text",
      "name": "txtShipment",
      "placeholder": "Enter AWB Number",
      "onkeypress": "return event.charCode >= 48 && event.charCode <= 57",
      "disabled": _vm.disabled == 1 ? true : false
    },
    domProps: {
      "value": (_vm.txtShipment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShipment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.txtShipment')),
      expression: "errors.has('form-2.txtShipment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter AWB Number.")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": _vm.show
    }
  }, [_vm._v("Show")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ddlHub),
      expression: "ddlHub"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ddlHub')
    },
    attrs: {
      "id": "ddlHub",
      "name": "ddlHub",
      "disabled": _vm.disabledHub == 1 ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ddlHub = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Final Destination--")]), _vm._v(" "), _vm._l((_vm.getHubObj), function(getHub_obj) {
    return _c('option', {
      domProps: {
        "value": getHub_obj.HubID
      }
    }, [_vm._v(_vm._s(getHub_obj.HubName))])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.ddlHub')),
      expression: "errors.has('form-2.ddlHub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select hub.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(13), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "rows": "2",
      "name": "comments",
      "id": "comments"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.comments')),
      expression: "errors.has('form-2.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Commnets.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(14), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    on: {
      "click": _vm.clear
    }
  }), _vm._v("Clear")])])])])]) : _vm._e()])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Parent MPS : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Show")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                       Shipping address:\n                     ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                       Shipping State:\n                     ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                       Shipping City:\n                     ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                       Mobile No :\n                     ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                       Shipping Pin :\n                     ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("\n                       Reason :\n                     ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Update ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Update Final Destination ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("AWB Type ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(" AWB No : ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Final Destination :")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-3"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('div', [_vm._v("Comments:")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Update ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c60d18b","hasScoped":true}!./src/views/components/CargoShiftShipmentDestinationHub/CargoShiftShipmentDestinationHub.component.html
// module id = 1018
// module chunks = 1